

const Scheduling = ({
    pageRefs,
    currentPage,
    logo,
    pageTitles,
    SurgeryFormData,
    surgeonOptionsMap,
    docSignature,
    setSignatures,
    setSurgeryFormData,
    handleInputChange,
    invalidFields,
    isNext,
    isEditing,
    signatures,
    canvasRefs,
    updateSignatureData,
    clearSignature,
    toggleEditMode,
    getCentralAmericaDate,
    getCentralAmericaTime,
    Logo,
    Head,
    Paragraph,
    RadioGroup,
    TextInput,
    SignatureField,
    SegLogoBanner,
    Initials,
    surgeryUpload,
    FormInput,
    formattedDate,
    handleCheckboxChange,
    MultiSelector,
    CheckboxField,
    MultiSelectorWithoutEyes,
    MultiFieldSelector,
    handleChange
}) => {

    return (
        <div ref={pageRefs.current[currentPage]} className="max-w-5xl w-full bg-white">
            <div className="px-1 mx-8 py-2">
                <Paragraph>
                    Patient Name: <span className="underline font-bold">{SurgeryFormData.first_name} {SurgeryFormData.last_name}</span>  DOB: <span className="underline font-bold">{SurgeryFormData.dob}</span>
                </Paragraph>

                <TextInput
                    id="referring_doctor"
                    label="Referring Doctor"
                    value={SurgeryFormData.referring_doctor}
                    onChange={handleInputChange}
                    disabled={isNext}
                    invalid={invalidFields.includes("referring_doctor") && !SurgeryFormData.referring_doctor}
                />


                <div htmlFor='interpreter' className="justify-center flex items-center space-x-2 select-none my-4">
                    <CheckboxField
                        id="interpreter"
                        label="Comanaged with referring doctor"
                        disabled={isNext}
                        checked={SurgeryFormData.comanaged === true}
                        onChange={() =>
                            setSurgeryFormData((prev) => ({
                                ...prev,
                                comanaged: !prev.comanaged,
                            }))
                        }
                    />
                </div>
                <div className="my-3 grid grid-cols-1 lg:grid-cols-2 gap-3">
                    <div className="p-3 rounded-2xl border bg-gray-50">
                        <h3 className="text-sm font-semibold text-gray-700 mb-2">OS</h3>
                        <MultiSelector
                            packages={SurgeryFormData.package.os}
                            onChange={(pkg, value) =>
                                handleCheckboxChange("package.os", pkg, value)
                            }
                        />
                    </div>
                    <div className="p-3 rounded-2xl border bg-gray-50">
                        <h3 className="text-sm font-semibold text-gray-700 mb-2">OD</h3>
                        <MultiSelector
                            packages={SurgeryFormData.package.od}
                            onChange={(pkg, value) =>
                                handleCheckboxChange("package.od", pkg, value)
                            }
                        />
                    </div>
                </div>

                <div className="my-3 grid grid-cols-1 lg:grid-cols-2 gap-3">
                    <div className="p-3 rounded-2xl border bg-gray-50">
                        <h3 className="text-sm font-semibold text-gray-700 mb-2">IOL - OS</h3>
                        <MultiSelector
                            packages={SurgeryFormData.iol.os}
                            onChange={(pkg, value) =>
                                handleCheckboxChange("iol.os", pkg, value)
                            }
                            label=""
                        />
                    </div>

                    <div className="p-3 rounded-2xl border bg-gray-50">
                        <h3 className="text-sm font-semibold text-gray-700 mb-2">IOL - OD</h3>
                        <MultiSelector
                            packages={SurgeryFormData.iol.od}
                            onChange={(pkg, value) =>
                                handleCheckboxChange("iol.od", pkg, value)
                            }
                            label=""
                        />
                    </div>
                </div>

                <div className="my-3 grid grid-cols-1 lg:grid-cols-2 gap-3">
                    <div className="p-3 rounded-2xl border bg-gray-50">
                        <h3 className="text-sm font-semibold text-gray-700 mb-2">Toric/LRI - OS</h3>
                        <MultiSelector
                            packages={SurgeryFormData.toric_lri.os}
                            onChange={(pkg, value) =>
                                handleCheckboxChange("toric_lri.os", pkg, value)
                            }
                            label=""
                        />
                    </div>

                    <div className="p-3 rounded-2xl border bg-gray-50">
                        <h3 className="text-sm font-semibold text-gray-700 mb-2">Toric/LRI - OD</h3>
                        <MultiSelector
                            packages={SurgeryFormData.toric_lri.od}
                            onChange={(pkg, value) =>
                                handleCheckboxChange("toric_lri.od", pkg, value)
                            }
                            label=""
                        />
                    </div>
                </div>

                <div className="my-3 grid grid-cols-1 lg:grid-cols-2 gap-3">
                    <div>
                        <TextInput
                            id="lal_plus_text_os"
                            label="LAL Plus Text - OS"
                            value={SurgeryFormData.lal_plus_text.os}
                            onChange={(e) => {
                                setSurgeryFormData(prev => ({
                                    ...prev,
                                    lal_plus_text: {
                                        ...prev.lal_plus_text,
                                        os: e.target.value
                                    }
                                }))
                            }}
                            disabled={isNext}
                            invalid={invalidFields.includes("lal_plus_text_os") && !SurgeryFormData.lal_plus_text.os}
                        />
                    </div>

                    <div>
                        <TextInput
                            id="lal_plus_text_od"
                            label="LAL Plus Text - OD"
                            value={SurgeryFormData.lal_plus_text.od}
                            onChange={(e) => {
                                setSurgeryFormData(prev => ({
                                    ...prev,
                                    lal_plus_text: {
                                        ...prev.lal_plus_text,
                                        od: e.target.value
                                    }
                                }))
                            }}
                            disabled={isNext}
                            invalid={invalidFields.includes("lal_plus_text_od") && !SurgeryFormData.lal_plus_text.od}
                        />
                    </div>
                </div>

                <div className="my-3 grid grid-cols-1 lg:grid-cols-2 gap-3">
                    <div className="p-3 rounded-2xl border bg-gray-50">
                        <h3 className="text-sm font-semibold text-gray-700 mb-2">LAL Plus - OS</h3>
                        <MultiSelector
                            packages={SurgeryFormData.lal_plus.os}
                            onChange={(pkg, value) =>
                                handleCheckboxChange("lal_plus.os", pkg, value)
                            }
                            label=""
                        />
                    </div>

                    <div className="p-3 rounded-2xl border bg-gray-50">
                        <h3 className="text-sm font-semibold text-gray-700 mb-2">LAL Plus - OD</h3>
                        <MultiSelector
                            packages={SurgeryFormData.lal_plus.od}
                            onChange={(pkg, value) =>
                                handleCheckboxChange("lal_plus.od", pkg, value)
                            }
                            label=""
                        />
                    </div>
                </div>

                <div className="my-3">
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 items-end">
                        <h3 className="text-sm font-semibold text-gray-700 justify-center items-center flex">
                            Target
                        </h3>

                        {[
                            {
                                id: "os",
                                label: "OS",
                            },
                            {
                                id: "od",
                                label: "OD",
                            },
                        ].map(({ id, label }) => (
                            <div
                                key={id}
                                className="bg-white"
                            >
                                <FormInput
                                    id={id}
                                    label={label}
                                    type="text"
                                    disabled={isNext}
                                    value={SurgeryFormData.target[id]}
                                    onChange={handleInputChange}
                                    invalid={
                                        invalidFields.includes(id) &&
                                        !SurgeryFormData.target[id]
                                    }
                                />
                            </div>
                        ))}
                    </div>
                </div>



                <div className="my-3 grid grid-cols-1 lg:grid-cols-2 gap-3">
                    <div className="p-3 rounded-2xl border bg-gray-50">
                        <h3 className="text-sm font-semibold text-gray-700 mb-2">LASIK/PRK/RK - OS</h3>
                        <MultiSelectorWithoutEyes
                            packages={SurgeryFormData.lasik_prk_rk.os}
                            onChange={(pkg, value) =>
                                handleCheckboxChange("lasik_prk_rk.os", pkg, value)
                            }
                            label=""
                        />
                    </div>

                    <div className="p-3 rounded-2xl border bg-gray-50">
                        <h3 className="text-sm font-semibold text-gray-700 mb-2">LASIK/PRK/RK - OD</h3>
                        <MultiSelectorWithoutEyes
                            packages={SurgeryFormData.lasik_prk_rk.od}
                            onChange={(pkg, value) =>
                                handleCheckboxChange("lasik_prk_rk.od", pkg, value)
                            }
                            label=""
                        />
                    </div>
                </div>


                <div className="my-3 grid grid-cols-1 lg:grid-cols-2 gap-3">
                    <CheckboxField
                        id="blood_thinner"
                        label="Blood Thinners"
                        disabled={isNext}
                        checked={SurgeryFormData.blood_thinner}
                        onChange={() =>
                            setSurgeryFormData((prev) => ({
                                ...prev,
                                blood_thinner: !prev.blood_thinner,
                            }))
                        }
                    />
                    <TextInput
                        id="blood_thinner_text"
                        label=""
                        value={SurgeryFormData.blood_thinner_text}
                        onChange={handleInputChange}
                        disabled={isNext}
                        invalid={invalidFields.includes("blood_thinner_text") && !SurgeryFormData.blood_thinner_text}
                    />
                </div>

                <div className="flex items-center justify-center">
                    <CheckboxField
                        id="glasses_after_surgery"
                        label="PT ok to wear glasses or contacts after surgery"
                        disabled={isNext}
                        checked={SurgeryFormData.glasses_after_surgery}
                        onChange={() =>
                            setSurgeryFormData((prev) => ({
                                ...prev,
                                glasses_after_surgery: !prev.glasses_after_surgery,
                            }))
                        }
                    />
                </div>

                <div className="my-3 grid grid-cols-1 lg:grid-cols-2 gap-3">

                    <MultiFieldSelector
                        label="OS"
                        data={SurgeryFormData.os}
                        onChange={(field, value) =>
                            handleChange("os", field, value)
                        }
                    />

                    <MultiFieldSelector
                        label="OD"
                        data={SurgeryFormData.od}
                        onChange={(field, value) =>
                            handleChange("od", field, value)
                        }
                    />
                </div>
                <div className="my-3 grid grid-cols-1 lg:grid-cols-2 gap-3">
                    <div className="p-3 rounded-2xl border bg-gray-50">
                        <h3 className="text-sm font-semibold text-gray-700 mb-2">MIGS - OS</h3>
                        <MultiSelectorWithoutEyes
                            packages={SurgeryFormData.migs.os}
                            onChange={(pkg, value) =>
                                handleCheckboxChange("migs.os", pkg, value)
                            }
                            label=""
                        />
                    </div>

                    <div className="p-3 rounded-2xl border bg-gray-50">
                        <h3 className="text-sm font-semibold text-gray-700 mb-2">MIGS - OD</h3>
                        <MultiSelectorWithoutEyes
                            packages={SurgeryFormData.migs.od}
                            onChange={(pkg, value) =>
                                handleCheckboxChange("migs.od", pkg, value)
                            }
                            label=""
                        />
                    </div>
                </div>

                <div className="my-3 grid grid-cols-1 lg:grid-cols-2 gap-3">
                    <div className="p-3 rounded-2xl border bg-gray-50">
                        <h3 className="text-sm font-semibold text-gray-700 mb-2">MIGS Procedure - OS</h3>
                        <MultiSelectorWithoutEyes
                            packages={SurgeryFormData.migs_procedure.os}
                            onChange={(pkg, value) =>
                                handleCheckboxChange("migs_procedure.os", pkg, value)
                            }
                            label=""
                        />
                    </div>

                    <div className="p-3 rounded-2xl border bg-gray-50">
                        <h3 className="text-sm font-semibold text-gray-700 mb-2">MIGS Procedure - OD</h3>
                        <MultiSelectorWithoutEyes
                            packages={SurgeryFormData.migs_procedure.od}
                            onChange={(pkg, value) =>
                                handleCheckboxChange("migs_procedure.od", pkg, value)
                            }
                            label=""
                        />
                    </div>
                </div>



                <TextInput
                    id="doctor_comments"
                    label="Doctor's Comments"
                    value={SurgeryFormData.doctor_comments}
                    onChange={handleInputChange}
                    disabled={isNext}
                    invalid={invalidFields.includes("doctor_comments") && !SurgeryFormData.doctor_comments}
                />



            </div>
        </div >
    );
};

export default Scheduling;